import { Input as InputAntD, Form } from "antd";
import "./Input.scss";

interface InputProps {
  name: string;
  placeholder?: string;
  isPassword?: boolean;
  isRequired?: boolean;
  isEmail?: boolean;
  requiredMessage?: string;
  isTextArea?: boolean;
}

export const Input = ({
  name,
  placeholder,
  isPassword,
  isRequired,
  requiredMessage,
  isEmail,
  isTextArea,
}: InputProps) => {
  const rules: any[] = [{ required: isRequired, message: requiredMessage }];

  if (isEmail) {
    rules.push({ type: "email", message: "Please enter a valid email" });
  }

  return (
    <Form.Item name={name} rules={rules}>
      {isPassword ? (
        <InputAntD.Password className="cp-input" placeholder={placeholder} />
      ) : isTextArea ? (
        <InputAntD.TextArea className="cp-input" placeholder={placeholder} />
      ) : (
        <InputAntD className="cp-input" placeholder={placeholder} />
      )}
    </Form.Item>
  );
};

export default Input;
